import clsx from 'clsx';
import config from 'config-base';
import styles from './Rating.module.css';

export type RatingProps = {
  defaultValue: number;
  reviewers: number | undefined;
  ratingContainerClasses?: string;
  ratingDescription?: string;
  ratingTextClasses?: string;
  hideRating?: boolean;
  width?: number;
  height?: number;
};

const ratingNumber = (rating: number) => {
  return rating.toFixed(1).toString().replace('.', '');
};

const Rating = ({
  defaultValue,
  reviewers,
  ratingContainerClasses,
  ratingTextClasses,
  hideRating = false,
  ratingDescription = '',
  width = 96,
  height = 16,
}: RatingProps) => {
  return (
    <div className={clsx(styles.rating, ratingContainerClasses)}>
      <img
        src={`/marketplace-static/images/stars/${config.brandCode === '2' ? 'agd' : ''}cnt${ratingNumber(
          defaultValue,
        )}.svg`}
        alt="rating"
        width={width}
        height={height}
      />
      <div className={clsx(styles.ratingText, ratingTextClasses, 'ratingText')}>
        {!hideRating && `${parseFloat(defaultValue.toFixed(1))}`}
        {`(${reviewers || '0'}${ratingDescription})`}
      </div>
    </div>
  );
};

export default Rating;
